module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "OT"
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('p', {
    staticClass: "TocSb1",
    attrs: {
      "id": "pre"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_iii"
    }
  }), _c('a', {
    attrs: {
      "href": "#/xhtml/preface#pre"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1",
    attrs: {
      "id": "abb"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/abbreviations#abb"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2",
    attrs: {
      "id": "ch-001"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 and 2 Thessalonians")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s1"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s2"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Situation of the Christian Community in Thessalonica")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Thessalonians: Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction and the Great Thanksgiving (1:1–3:13)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Issue of Marriage (4:1–8)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Issue of Communal Self Reliance in Love (4:9–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Issue of the Dead (4:13–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Issue of the Eschaton (5:1–11)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Issues of Congregational Life (5:12–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Blessings (5:12–22)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "ch1-s11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Thessalonians: Commentary")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Introduction, Thanksgiving, and Prayer (1:1–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Two Theses of the Letter (2:1–2)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Argument That the Parousia Has Not Yet Come (2:3–12)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Argument That Believers Will Persist until the Parousia (2:13–3:5)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Exhortations to the Disorderly (3:6–15)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc1a",
    attrs: {
      "id": "ch1-s17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter001#ch1-s17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Concluding Benediction and Greetings (3:16–18)")])]), _vm._v(" "), _c('p', {
    staticClass: "Toc2a",
    attrs: {
      "id": "back"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/back#back",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Get the Complete Commentary!")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef6128c6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 63
// module chunks = 0